/**
 * This is the brand-color (+) button used in cells to indicate that you can click into more content.
 * This is reused in TradeInValue, BankOffersCell
 */
import React from "react";
import styled from "styled-components";
import PlusIcon from "src/components/icons/Plus";

const Button = styled("button")`
    background: none;
    border: none;
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    font-size: 1em;
    outline: 0;
    padding: 0;
`;

const ButtonIcon = styled(PlusIcon)`
    color: ${(props) => props.theme.palette.primary.main};
    height: 15px;
    width: 15px;
`;

const RightFullHeight = styled("div")`
    float: right;
    height: 100%;
    margin-right: 0.5em;
    display: flex;
    align-items: center;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        margin-right: 1em;
    }
`;

const CellPlusButton = () => {
    return (
        <Button className="clickable">
            <ButtonIcon />
        </Button>
    );
};

export default CellPlusButton;

export const PositionedCellPlusButton = () => {
    return (
        <RightFullHeight>
            <CellPlusButton />
        </RightFullHeight>
    );
};
